import { render } from "./equipment-spareparts.vue?vue&type=template&id=05bbfe16&ts=true"
import script from "./equipment-spareparts.vue?vue&type=script&lang=ts"
export * from "./equipment-spareparts.vue?vue&type=script&lang=ts"

import "./equipment-spareparts.vue?vue&type=style&index=0&id=05bbfe16&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__